export default "__VITE_ASSET__04f826e4__"